import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { LoginService } from './login.service';

export const ragminGuard: CanActivateFn = async () => {
  const loginService = inject(LoginService);
  return (loginService.loggedInUser.permissions.indexOf("admin") >= 0)
    && loginService.loggedInUser.email.endsWith("@reflact.com");
};
